import { CSSProperties } from "react";

interface FrameBoxProps {
  children: React.ReactNode;
  style?: CSSProperties;
  contentStyle?: CSSProperties
}

export default function FrameBox({children, style, contentStyle }: FrameBoxProps) {
  return (
    <div className="theme-card-bg mx-2 rounded-[25px] p-5 flex flex-col overflow-hidden" style={style}>
      <div className="theme-scrollbar pr-2 flex-1 h-full text-[#4b4b4b] text-sm leading-relaxed" style={contentStyle}>
        {children}
      </div>
    </div>
  );
}
